import { UseQueryResult } from '@tanstack/react-query'

export const combineQueries = <TData>(results: UseQueryResult<TData>[]) => ({
    isPending: results.some(q => q.isPending),
    isLoading: results.some(q => q.isLoading),
    isFetching: results.some(q => q.isFetching),
    isSuccess: results.every(q => q.isSuccess),
    isError: results.some(q => q.isError),
    errors: results
        .filter(q => q.isError)
        .map(q => q.error.message)
        .filter((message): message is string => Boolean(message)),
    // data should only be used if strictly necessary. Get the entities from the store instead.
    data: results.map(q => q.data),
})

type QueryStatuses = {
    isPending: boolean
    isLoading: boolean
    isFetching: boolean
    isError: boolean
    isSuccess: boolean
}

export const mergeQueryStatuses = (...queries: QueryStatuses[]) => ({
    isPending: queries.some(q => q.isPending),
    isLoading: queries.some(q => q.isLoading),
    isFetching: queries.some(q => q.isFetching),
    isError: queries.some(q => q.isError),
    isSuccess: queries.every(q => q.isSuccess),
})
